/**
 * The public Flyers wanted page. It runs signed OUT, so it uses plain fetch,
 * never the authenticated client, and keeps the same JSON guard: a 200 that
 * is not JSON (Hosting's SPA catch-all) must not render as an empty list.
 */
export interface MissingShow {
  date: string;
  year: string;
  venue: string;
  state: string;
  event: string | null;
  bands: string;
}

export async function fetchMissing(fetcher: typeof fetch = fetch): Promise<MissingShow[]> {
  const res = await fetcher("/api/public/missing");
  const type = res.headers.get("content-type") ?? "";
  if (!res.ok || !/^application\/json\b(?!-)/.test(type)) {
    throw new Error("The list is unavailable right now.");
  }
  return ((await res.json()) as { shows: MissingShow[] }).shows;
}

/** Every word must match the bill, venue or event; newest first. */
export function filterMissing(shows: MissingShow[], q: string, year: string | null): MissingShow[] {
  const words = q.toLowerCase().split(/\s+/).filter(Boolean);
  return shows
    .filter((s) => !year || s.year === year)
    .filter((s) => {
      const hay = `${s.bands} ${s.venue} ${s.event ?? ""}`.toLowerCase();
      return words.every((w) => hay.includes(w));
    })
    .sort((a, b) => b.date.localeCompare(a.date));
}

export const missingYears = (shows: MissingShow[]) => [...new Set(shows.map((s) => s.year).filter(Boolean))].sort().reverse();

/** Some stored bills carry [brackets] for the flyer agent; readers do not need them. */
export const cleanBill = (bands: string) => bands.replace(/\[([^\]]+)\]/g, "$1");
